<template>
  <div class="skipwrap">
    <div class="skip">
      <img src="@/assets/img/loading.gif" style="width: 400px" alt="" />
      <div :class="[lang]">{{ $t("Dataisloading") }}</div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      userInfo: null,
    };
  },
  methods: {
    ...mapMutations("account", ["setUser", "setPermissions", "setRoles"]),
  },
  i18n: require("./i18n"),
  mounted() {
    this.getUserInfo().then(() => {
      let { url, queuepopup, campaign_type } = this.$route.query;
      if (campaign_type) {
        url = url + "&campaign_type=" + campaign_type;
      }
      if (queuepopup) {
        url = url + "?queuepopup=" + queuepopup;
      }
      this.$router.replace(url);
    });
  },
};
</script>
<style lang="less" scoped>
.skipwrap {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  .skip {
    margin-top: -250px;
    width: 400px;
    height: 203px;

    font-size: 16px;
    text-align: center;
  }
}
</style>
